module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av490-d287ef8d8418e7a2072daea14e221595.jpg";